export const normalizePathIdentifier = (path: string) => {
  const basePathMatch = path.match(/^(.*?\/\d+)(?:\/|\?|$)/);
  let normalizePath = basePathMatch ? basePathMatch[1] : path;

  normalizePath = normalizePath.replace(/\/+$/, '');

  return {
    normalizePath,
  };
};
